import { render, staticRenderFns } from "./app-box.vue?vue&type=template&id=3594c3a9"
import script from "./app-box.vue?vue&type=script&lang=ts"
export * from "./app-box.vue?vue&type=script&lang=ts"
import style0 from "./app-box.vue?vue&type=style&index=0&id=3594c3a9&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/volateq-web-app/volateq-web-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3594c3a9')) {
      api.createRecord('3594c3a9', component.options)
    } else {
      api.reload('3594c3a9', component.options)
    }
    module.hot.accept("./app-box.vue?vue&type=template&id=3594c3a9", function () {
      api.rerender('3594c3a9', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/app/shared/components/app-box/app-box.vue"
export default component.exports